import { useEffect } from 'react'

import useIsServer from './useIsServer'

const hide = (selector: string) => {
  const el: HTMLElement = document.querySelector(selector)
  if (el) {
    el.style.display = 'none'
  }
}

const show = (selector: string) => {
  const el: HTMLElement = document.querySelector(selector)
  if (el) {
    el.style.display = 'block'
  }
}

type RestoreFooterOptions = {
  hideOnUnmount?: boolean
}

export const useRestoreSiteFooter = (options?: RestoreFooterOptions) => {
  const isServer = useIsServer()

  useEffect(() => {
    if (!isServer) {
      show('#site-footer')
    }

    return () => {
      if (options?.hideOnUnmount) {
        hide('#site-footer')
      }
    }
  }, [isServer])
}

type HideFooterOptions = {
  restoreOnUnmount?: boolean
}

export const useHideSiteFooter = (options?: HideFooterOptions) => {
  const isServer = useIsServer()

  useEffect(() => {
    if (!isServer) {
      hide('#site-footer')
    }

    return () => {
      if (options?.restoreOnUnmount) {
        show('#site-footer')
      }
    }
  }, [isServer])
}
